import './DateInput.scss';

import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { toUTCDate } from 'dayjsConfig';
import React from 'react';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputHeader
} from '../_common';

interface DateInputProps {
  name: string;
  label?: string;
  options?: RegisterOptions;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  disabledDate?: (current: Dayjs) => boolean;
  inputNote?: InputNoteConfig;
  hideLabel?: boolean;
}

const DateInput = ({
  name,
  disabledDate,
  disabled,
  label,
  options,
  required,
  placeholder,
  inputNote,
  hideLabel
}: DateInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;

  return (
    <div className={getHookGroupClass(label, 'HookDateInput')}>
      {!hideLabel && renderHookInputHeader(name, label, required, inputNote)}
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <DatePicker
            {...field}
            format="L"
            id={name}
            showTime={false}
            showToday={false}
            disabledDate={disabledDate}
            className={getHookFieldClass(isTouched, invalid)}
            disabled={disabled}
            allowClear={!required}
            placeholder={placeholder}
            onChange={(value) => {
              if (value) {
                field.onChange(toUTCDate(value));
              } else {
                field.onChange('');
              }
            }}
            value={field.value ? dayjs(field.value) : undefined}
          />
        )}
      />
      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default DateInput;
